export default [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER','ROLE_TEAMS'],
            layout: 'default',
            breadcrumb: 'Accueil',
            description: 'Gestion du site tacoloco.fr'
        },

    },
    {
        path: '/home/service',
        name: 'service',
        component: () => import('../views/KanbanOrder.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER','ROLE_TEAMS'],
            layout: 'default',
            breadcrumb: 'Service du jour',
            description: 'Gestion des commandes passés sur tacoloco'
        }
    }
]
